module.exports = __webpack_public_path__ + "img/emoji.4f3a00e6.svg";